import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Spinner,
  Button,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import { useNotify } from "../../../shared/components/SuperToast";
import { useSelectedCiRelationTypesContext } from "../context/SelectedCiRelationTypesContext";
import { useDeleteCiRelationType } from "../hooks/useCiRelationTypeMutations";

function CiRelationTypeDeleteDialog({ isOpen, setIsOpen }) {
  const { t } = useTranslation();
  const { value: selectedItems } = useSelectedCiRelationTypesContext();
  const { notify } = useNotify();

  const {
    mutate: mutateDelete,
    isPending,
    error,
  } = useDeleteCiRelationType(
    "ci_relation_types",
    () => {
      notify(t("item.messages.deleted", { name: selectedItems[0].name }), "success");
      setIsOpen(false);
    },
    null,
  );

  const handleConfirmation = () => {
    const publicId = selectedItems?.[0]?.public_id;
    if (!publicId) throw new Error("No valid ID for CI relation type");
    mutateDelete(publicId);
  };

  if (!selectedItems?.[0]) return null;

  return (
    <Dialog modalType="alert" open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{selectedItems[0]?.name}</DialogTitle>
          <DialogContent>
            {t("item.questions.delete", { name: selectedItems[0]?.name })}
            {error && <div style={{ color: "red" }}>{error.message}</div>}
          </DialogContent>
        </DialogBody>
        <DialogActions>
          <Button appearance="primary" disabled={isPending} onClick={handleConfirmation}>
            {isPending ? <Spinner size="tiny" /> : t("generic.confirm")}
          </Button>
          <Button appearance="secondary" disabled={isPending} onClick={() => setIsOpen(false)}>
            {t("generic.cancel")}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default CiRelationTypeDeleteDialog;
